export default "__VITE_ASSET__f7a26631__"